/* istanbul ignore file */
import React from 'react';

import { MenuItemSkeleton } from '@lumapps/lumx-menu/components/Menu/Skeleton/MenuItemSkeleton';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { SettingsMenuModulesSpacesProps } from './SettingsMenuModulesSpaces';

const LazySettingsMenuModulesSpaces = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'settings-menu-modules-spaces' */
        './SettingsMenuModulesSpaces'
    );

    return { default: resolved.SettingsMenuModulesSpaces };
});

const SettingsMenuModulesSpaces = (props: SettingsMenuModulesSpacesProps) => {
    const { translateKey } = useTranslate();

    return (
        <Suspense loadingFallback={<MenuItemSkeleton hasIcon loadingMessage={translateKey(GLOBAL.LOADING)} />}>
            <LazySettingsMenuModulesSpaces {...props} />
        </Suspense>
    );
};

export { SettingsMenuModulesSpaces };
